import { ColumnModel } from './../../definition/column.model';
import { Component, OnInit, Input, ViewChild, Output, EventEmitter, TemplateRef } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { GenericApiFactory } from 'shared/factories/generic-api.factory';
import { GenericApiService, SpinningService } from 'shared/services';
import { ReplaySubject } from 'rxjs';
import { PagedResultModel } from 'shared/definition';
import { columnTypes } from 'shared/consts/column-types';
import { NzTableComponent } from 'ng-zorro-antd/table';

@Component({
  selector: 'wx-page-data-table',
  templateUrl: './page-data-table.component.html',
  styleUrls: ['./page-data-table.component.scss']
})
export class PageDataTableComponent<T> implements OnInit {

  @Input() queryResult$ = new ReplaySubject<PagedResultModel<T>>();
  @Input() queryModel: any;
  @Input() columnList: Array<ColumnModel>;
  @Input() apiName: string;
  @Input() authorizeBase = '';
  @Output() editEmmiter: EventEmitter<T> = new EventEmitter<T>();
  @Output() delEmmiter: EventEmitter<T> = new EventEmitter<T>();
  @Output() statusEmmiter: EventEmitter<T> = new EventEmitter<T>();
  @Input() actionTemplate?: TemplateRef<any>;

  @Input() showTotal = true;

  @Input() simple = false;

  @Input() detailTemplate?: TemplateRef<any>;
  @Input() actionWidth?: number;//操作列宽度
  @Input() scroll?: any;//操作列宽度

  @Input() isInit?: boolean = true;// 初始化时默认加载数据

  columnTypes = columnTypes;//列类型

  data$ = this.queryResult$.pipe(
    map(r => r.data)
  )
  pageIndex$ = this.queryResult$.pipe(
    map(r => r.pageIndex)
  )

  pageSize$ = this.queryResult$.pipe(
    map(r => r.pageSize)
  )
  totalCount$ = this.queryResult$.pipe(
    map(r => r.totalCount)
  )

  pageIndex = 0;

  @ViewChild(NzTableComponent, { static: true })
  table: NzTableComponent;

  get tableData() {
    return this.table.data as T[];
  }
  onCloseForm = new EventEmitter<boolean>();
  expandSet = new Set<string>();
  api: GenericApiService<T, any>;
  constructor(
    private spinning: SpinningService,
    private apiFactory: GenericApiFactory
  ) {
  }

  ngOnInit(): void {
    this.api = this.apiFactory.create<T, any>(this.apiName);
    if (this.isInit) {
      this.api.query(
        this.queryModel ? this.queryModel : {}
      ).pipe(
        tap(result => {
          this.queryResult$.next(result);
        })
      ).subscribe();
    }

    this.onCloseForm.subscribe(result => {
      if (result) {
        this.api.query(this.queryModel).subscribe(result => {
          this.queryResult$.next(result);
        });
      }
    })
  }

  onPageIndexChagne(pageIndex: number) {
    this.pageIndex = pageIndex;
    const query = {
      ...this.queryModel,
      ...{
        pageIndex: (pageIndex)
      }
    }
    this.spinning.startWith(this.api.query(query)).pipe(
      tap(result => {
        this.queryResult$.next(result);
        this.queryModel = query;
      })
    ).subscribe();
  }


  pageSizeChange(pageSize: number) {
    this.queryModel.pageIndex = 1;
    this.queryModel.pageSize = pageSize;
    const query = {
      ...this.queryModel,
      ...{
        pageSize: (pageSize)
      }
    };
    this.spinning.startWith(this.api.query(query)).pipe(
      tap(result => {
        this.queryResult$.next(result);
        this.queryModel = query;
      })
    ).subscribe();
  }

  search(query: any) {
    query.pageSize = this.queryModel.pageSize;
    this.spinning.startWith(this.api.query(query)).pipe(
      tap(result => {
        this.queryModel = query;
        this.queryResult$.next(result);
      })
    ).subscribe();
  }

  onExpandChange(id: string, checked: boolean): void {
    if (checked) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }
  }

  getId(item: T) {
    return (item as any).id;
  }

  refresh() {

    this.spinning.startWith(this.api.query(this.queryModel)).pipe(
      tap(result => {
        this.queryResult$.next(result);
      })
    ).subscribe()

  }

  isPlural(total: number, path: string): string {
    return total > 1 ? `${path}s` : path;
  }
}
